/**
 * <mf-quick-buy>: a second add-to-cart button under the product gallery.
 * The button submits the product form itself (form attribute), so it works before any script has loaded and the
 * form's own script handles the add once it has. This script only covers the case the form button would refuse:
 * when the selected variant can't be bought, it scrolls the shopper to the form instead of submitting.
 */
class MfQuickBuy extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.querySelector('button')?.addEventListener('click', (event) => this.#onClick(event), { signal: this.#abort.signal });
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @param {MouseEvent} event */
  #onClick(event) {
    const form = document.getElementById(this.dataset.formId || '');
    if (!(form instanceof HTMLFormElement)) return;

    const button = form.querySelector('[ref="addToCartButton"]') || form.querySelector('button[type="submit"]');
    if (button instanceof HTMLButtonElement && button.disabled) {
      event.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

if (!customElements.get('mf-quick-buy')) customElements.define('mf-quick-buy', MfQuickBuy);
